export const getSolidLightColor = site => {
  const studyGradient = "#D61772"
  const businessGradient = "#F36C23"
  const workGradient = "#B950A2"
  const liveGradient = "#78BE20"
  const visitGradient = "#00ADD7"

  if (site === "work") {
    return workGradient
  } else if (site === "business") {
    return businessGradient
  } else if (site === "live") {
    return liveGradient
  } else if (site === "visit") {
    return visitGradient
  } else if (site === "study") {
    return studyGradient
  } else {
    return studyGradient
  }
}
